import React, { Component } from "react";
import "./App.css";
import Navbar from "./component/navbar";
import Hero from "./component/hero";
import Contact from "./component/contacts";
import Services from "./component/services";
import About from "./component/about";
import Footer from "./component/footer";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
